import { useLang } from "../../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

export const Production = () => {
  const { t } = useLang();
  const p = t.production;

  return (
    <section id="production" className="bg-background border-b border-border" data-testid="production">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <Reveal>
              <Overline index="02">{p.label}</Overline>
              <h2 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight text-nero-ink leading-[1.05]">
                {p.title}
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-4 lg:col-start-9">
            <Reveal delay={0.1}>
              <p className="font-body text-base leading-relaxed text-zinc-600">{p.text}</p>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-5 border-t border-l border-border">
          {p.steps.map((s, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div
                className="group relative h-full bg-white border-b border-r border-border p-7 lg:p-8 min-h-[230px] flex flex-col hover:bg-nero-ink transition-colors duration-300"
                data-testid={`production-step-${i}`}
              >
                <span className="font-heading text-5xl font-medium text-zinc-200 group-hover:text-nero-green transition-colors">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="mt-auto pt-8">
                  <h3 className="font-heading text-base font-medium tracking-tight text-nero-ink leading-snug group-hover:text-white transition-colors">
                    {s.title}
                  </h3>
                  <p className="mt-2 font-body text-sm leading-relaxed text-zinc-500 group-hover:text-white/55 transition-colors">
                    {s.text}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
